import { IProtectionSite } from './protection-site.interface';

export class ProtectionSite implements IProtectionSite {
  constructor(
    public readonly alarme: boolean,
    public readonly cameraInterieure: boolean,
    public readonly cameraExterieure: boolean,
    public readonly autre?: string
  ) {}

  public static hydrate(protectionSite: IProtectionSite): IProtectionSite {
    return new ProtectionSite(
      protectionSite.alarme,
      protectionSite.cameraInterieure,
      protectionSite.cameraExterieure,
      protectionSite.autre
    );
  }

  public clone(): IProtectionSite {
    return ProtectionSite.hydrate(this);
  }
}
